
import { AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SettingsService } from '../settings.service';
  
  export class FullNameValidator {
    static createValidator(settingService: SettingsService): AsyncValidatorFn {
      return (control: AbstractControl): Observable<ValidationErrors> => {
        return settingService
          .checkCustomerNameExists(control.value)
          .pipe(
            map((result: any) =>{
              
              if(result.customerNameExists){ 
                return {customerNameExists: true }
              }else{
                return null
              } 
            })
          );
      };
    }
  }